const separators = [
  " ",
  "\\+",
  "-",
  "\\(",
  "\\)",
  "\\*",
  "/",
  ":",
  "\\?",
  "\\.",
  "\\,",
];

export const IGNORED_WORDS = [
  "the",
  "etc",
  "was",
  "in",
  "as",
  "a",
  "by",
  "we",
  "and",
  "of",
  "our",
  "is",
  "to",
  "it",
  "an",
  "has",
  "for",
  "this",
  "that",
  "on",
  "who",
  "also",
  "your",
  "etc's",
  "it's",
  "using",
  "all",
  "from",
  "or",
  "how",
  "why",
  "if",
  "with",
  "about",
  "into",
];

export function generateUniqueKeywords(input) {
  return input
    .replace(/&nbsp;/g, " ")
    .split(new RegExp(separators.join("|"), "g"))
    .filter((item) => item !== "")
    .filter((item) => item !== "&")
    .map((item) => item.toLowerCase());
}

export function generateKeywordsFromString(input) {
  return input
    .split(new RegExp(separators.join("|"), "g"))
    .filter((item) => item !== "")
    .map((item) => item.toLowerCase());
}
